import React from 'react';
import {
  Link,
  Menu,
  MenuContent,
  MenuItem,
  MenuTrigger,
  CrosshairIcon,
} from '@packages/systems/spring';

const MENU_LABEL = 'Add field';

export const TokenSelect = ({
  tokens,
  onTokenClick,
}: {
  tokens: {label: string; value: string}[];
  onTokenClick: (value: string) => void;
}) => {
  return (
    <Menu shouldCloseOnClickItem>
      <MenuTrigger
        colorVariant="blue"
        prefix={<CrosshairIcon size={8} />}
        variant="ghost"
      >
        <Link>{MENU_LABEL}</Link>
      </MenuTrigger>
      <MenuContent>
        {tokens.map(({label, value}) => (
          <MenuItem
            key={value}
            onClick={() => onTokenClick(value)}
            shouldCloseOnClickItem
          >
            {label}
          </MenuItem>
        ))}
      </MenuContent>
    </Menu>
  );
};
